// src/components/Layout/SidebarLayout.jsx
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import css from "./TopbarLayout.module.css";
import { AdminBar } from "./AdminBar";

export const TopbarLayout = () => {
  const { pathname } = useLocation();

  function getSidebar() {
    switch (true) {
      case pathname.split("/")[1] === "admin":
        return <AdminBar />;
      default:
        return null;
    }
  }

  return (
    <div>
      <Header />
      <div className={css.body}>
        <main className={css.main}>
          {getSidebar()}
          <Outlet />
        </main>
      </div>
    </div>
  );
};
